import { AppCard, AppPage } from '../../components/general';
import { BreadcrumbItem } from '../../components/general/AppPage';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useAuth } from '@mezzodevelopment/mezzo-ui/auth';
import { Waterfalls } from './Waterfalls';
import { useWaterfalls } from '../../hooks/useWaterfalls';
import { WaterfallViewModel } from '../../models/waterfall';

interface WaterfallsContainerProps {
  integrationType?: string;
  title?: string;
  basePath?: string;
  breadcrumbs?: BreadcrumbItem[];
}

export const WaterfallsContainer = ({ integrationType, title = 'Waterfalls', basePath = '/waterfalls', breadcrumbs }: WaterfallsContainerProps) => {
  const { user, isLoading: authIsLoading } = useAuth();
  const { waterfallsQuery, deleteWaterfall } = useWaterfalls();

  const isLoading = authIsLoading || !user || waterfallsQuery.isLoading;

  if (isLoading) {
    return (
      <AppPage title={title} breadcrumbs={breadcrumbs || [{ label: 'Dashboard', to: '/dashboard' }, { label: title }]}>
        <AppCard>
          <div className="flex flex-column align-items-center justify-content-center gap-2">
            <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
            <span>Loading Waterfalls...</span>
          </div>
        </AppCard>
      </AppPage>
    );
  }

  return (
    <Waterfalls
      waterfalls={(waterfallsQuery.data ?? []) as WaterfallViewModel[]}
      onDelete={(id) => {
        if (id == null) return;
        deleteWaterfall(id);
      }}
      integrationType={integrationType}
      title={title}
      basePath={basePath}
      breadcrumbs={breadcrumbs}
    />
  );
};
